const $ = window.jQuery;

const filterCategory = {
    init: () => {


        const eventSelect = $(".countries-select-container");
        if ($(".domain-category-section").length) {

            eventSelect.val(window.location.href); // Select the option with a value of '1'
            console.log(window.location.href);
            eventSelect.trigger('change'); // Notify any JS components that the value changed


            eventSelect.select2({
                placeholder: "Select Domain",
                dropdownCssClass: "country-container"
            })
                .on('select2:open', function(e){
                    $(document.body).find('.select2-dropdown').addClass('animate-dropdown');
                }).on('select2:closing', function(e){
                    $(document.body).find('.select2-dropdown').removeClass('animate-dropdown');
            });


            eventSelect.on('select2:select', function(e) {
                var data = e.params.data;
                var url = $(data.element).data('url');
                var target = $(data.element).data('target');

                window.open(url, target);
                eventSelect.val(window.location.href); // Select the option with a value of '1
                eventSelect.trigger('change'); // Notify any JS components that the value changed
            })


        }

    }
};
export default filterCategory;
